import React, { Component } from "react";
import openMenu from "../assets/images/open-menu.svg";
import closeMenu from "../assets/images/close-black.svg";
import { Link, } from "react-router-dom";
import { globalLogout } from "../utils/auth";

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor'

//Service import 
import service from '../services'

let sub;
const mapStateToProps = state => ({
    getLoginUser: state.getLoginUser,
    getLoginRole: state.getLoginRole,
    profileName: state.profileName,
    getBackToAdminFlag: state.getBackToAdminFlag,
    getBackToAdminPreviousPath: state.getBackToAdminPreviousPath
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logoutLink: '',
            mount: false
        };
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        let logout = localStorage.getItem('loginToken');
        this.setState({
            logoutLink: logout
        })
    }
    componentDidMount = () => {
        let logout = localStorage.getItem('loginToken');
        this.setState({
            logoutLink: logout
        })
        var self = this;
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "authentication":
                    if(response.error){
                        if (response.code === '401') {
                            this.logOut()
                        }
                    }else{
                    let data = response.data;
                    self.props.LoginRole(data)
                    localStorage.setItem('loginToken', response.data.token)
                    if (data.user.role === "sio" || data.user.role === "press" || data.user.role === "sundanceGuest" || data.user.role === "general" || data.user.role === "artist") {
                        if (self.state.mount)
                        self.props.getBackToAdminFlag ? self.props.history.push('/admin-dashboard') : self.props.history.push(window.location.pathname)
                        else self.setState({ mount: true });
                    } else if (data.user.role === "partner") {
                        if (self.state.mount)
                            self.props.history.push('/profile-partner-view')
                        else self.setState({ mount: true });
                    }
                    else if (data.user.role === "satellite") {
                        if (self.state.mount)
                            self.props.history.push('/profile-satellite-view')
                        else self.setState({ mount: true });
                    }
                    else if (data.user.role === "privateScreeningPartner") {
                        if (self.state.mount)
                            self.props.history.push('/partners-film-view')
                        else self.setState({ mount: true });
                    }
                    else {
                        if (self.state && self.state.mount) {
                            if (self.props && self.props.getBackToAdminPreviousPath === 'privateScreeningPartner') {
                                self.props.BackToAdminPreviousPath('')
                                self.props.history.push('/partners-list')
                            }
                            else if (self.props && self.props.getBackToAdminPreviousPath === 'partner') {
                                this.props.history.push('/partners-view')
                                this.props.BackToAdminPreviousPath('')
                            } else if (self.props && self.props.getBackToAdminPreviousPath === 'satellite') {
                                this.props.history.push('/satellites-view')
                                this.props.BackToAdminPreviousPath('')
                            } else {
                                self.props.BackToAdminPreviousPath('')
                                if (sessionStorage.getItem('reAuth')) {
                                    console.log('hello');
                                }else {
                                    self.props.history.push(window.location.pathname === '/admin-dashboard' ? '/access-management' : window.location.pathname)
                                }
                            }
                        }
                        else self.setState({ mount: true });
                    }}
                    break;
                    case 'forceLogout':
                        this.logOut('FORCE')
                    break
            }
        })

    }

    loginSucess = () => {
        setTimeout(() => {
            this.props.history.push('/admin-dashboard')
            this.forceUpdate()
        }, 1000);
    }


    logOut = (TYPE) => {
        globalLogout(this.props.history, TYPE);
        this.setState({
            logoutLink: ""
        })
        this.props.BackToAdminFlag(false)
        this.props.ShortProgramEditData('')
        this.props.EpisodicShortProgramEditData('')
        this.props.filmEditData('')
        this.props.TalkEventEditData('')
        this.props.OtherEventsEditData('')
        this.props.NewFrontierEditData('')
        this.props.LiveSceeringEditData('')
        this.props.CurrentTab('')
        this.props.CurrentShortTab('')
    }

    backAdmin = (user) => {
        this.setState({ mount: true });
        localStorage.removeItem(user.role);
        this.props.BackToAdminFlag(false)
        if (user.role === "privateScreeningPartner") {
            this.props.BackToAdminPreviousPath('privateScreeningPartner')
        }
        if (user.role === "partner") {
            this.props.BackToAdminPreviousPath('partner')
        }
        if (user.role === "satellite") {
            this.props.BackToAdminPreviousPath('satellite')
        }
        localStorage.setItem('currentUserRole', 'admin')
        this.apiserve.sendevent("getUser", { id: this.props.getLoginUser && this.props.getLoginUser.user && this.props.getLoginUser.user._id });
        this.apiserve.sendevent("authentication", { token: this.props.getLoginUser.token, role:localStorage.getItem('currentUserRole') });
        this.props.LoginAdminByID("")
        this.props.profileName("")
    }

    render() {
        const { getLoginRole, profileName } = this.props
        const user = getLoginRole && getLoginRole.user && getLoginRole.user.role
        const isPrivateCMS = ['/ps-signin', '/ps-register', '/ps-reset', '/ps-forget'].includes(window.location.pathname) || false;
        return (
            <header>
                <div className="logo">
                    <img src={this.apiserve.imageUrl+'assest/'+process.env.REACT_APP_ENVIRONMENT+'/sundance_evergreen.png'} />
                </div>
                {
                    !this.state.logoutLink && !user && !profileName ?
                        <div className="title">
                            <h1>{isPrivateCMS ? 'PRIVATE SCREENING - Partner CMS' : 'SUNDANCE FILM FESTIVAL - CMS'}</h1>
                        </div>
                        :
                        ""
                }
                {
                    user && profileName && window.location.hostname === "cms.festival.sundance.org" && <div className="enviornment">
                        <p><span>{process.env.REACT_APP_ENVIRONMENT.slice(0, -1) + " " + process.env.REACT_APP_ENVIRONMENT.slice(-1) }</span> is live</p>
                    </div>
                }

                <div className="support_link">
                    {
                        !this.state.logoutLink && !user && !profileName ?
                            <a href="mailto:sff@sundance.org" target="_blank" >Contact Support</a>
                            :
                            ""
                    }
                    <div>
                        <span>{profileName && profileName.fname ? profileName && profileName.fname : profileName && profileName.contactFullName} {profileName && profileName.lname}</span>
                        {
                            this.props.getBackToAdminFlag ?
                                <span><Link onClick={() => this.backAdmin(getLoginRole.user)}>Back To Admin</Link></span>
                                : ''
                        }
                        {
                            this.state.logoutLink || user ?
                                <span><Link onClick={() => this.logOut()}>Log Out</Link></span>
                                :
                                ''
                        }
                    </div>
                    <button className="hamburger_wrapper" onClick={this.props.MenuToggle}>
                        <img className="openMenu" src={openMenu} />
                        <img className="closeMenu" src={closeMenu} />
                    </button>
                </div>
            </header>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Header)
